import React from 'react';
import { Reveal } from '../ui/Reveal';
import SafeIcon from '../common/SafeIcon';

const services = [
  {
    title: "Commercial Appraisal",
    icon: "Building",
    desc: "Valuation of Office, Retail, Multifamily, Industrial, and Mixed-Use."
  },
  {
    title: "Valuation Consulting",
    icon: "BarChart2",
    desc: "Investment analysis, portfolio valuations, and asset repositioning."
  },
  {
    title: "Litigation Support",
    icon: "Scale",
    desc: "Expert testimony, court-ready reports, and dispute resolution."
  }
];

const ServicesInfo = () => {
  return (
    <section id="services" className="bg-charcoal-950 py-24 pb-32">
      <div className="container mx-auto px-6 md:px-12">
        {/* Dark Container Block matching reference bottom section */}
        <div className="bg-charcoal-900 border border-white/5 p-12 max-w-6xl mx-auto rounded-sm">
          <div className="grid md:grid-cols-3 gap-12 divide-y md:divide-y-0 md:divide-x divide-white/10">
            {services.map((service, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className={`flex flex-col items-center text-center ${i !== 0 ? 'pt-8 md:pt-0' : ''} px-6`}>
                  <SafeIcon name={service.icon} className="text-gold-500 text-3xl mb-4" />
                  <h4 className="text-white font-bold text-lg mb-3">{service.title}</h4>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {service.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesInfo;